const siap = {
  C002TiposTitulo:         'SIAP/Catalogos/GetTiposTitulo',
  C025TiposNivelAcademico: 'SIAP/Catalogos/GetTiposNivelAcademico',
  C024TiposDocumento:      'SIAP/Catalogos/GetTiposDocumento',
  C022TiposMovimiento: 'SIAP/Catalogos/GetTiposMovimientos',
  C003TiposTurno: 'SIAP/Catalogos/GetTiposTurno',
  C028TiposPlaza: 'SIAP/Catalogos/GetTiposPlaza',
  C008TipoParentesco: 'SIAP/Catalogos/GetTiposParentesco',
  
  C036FundamentosLegales: 'SIAP/Catalogos/GetFundamentosLegales',
  C027TipoContrato: 'SIAP/Catalogos/GetTiposContrato',
  C032TipoEstatusIncidencia: 'SIAP/Catalogos/Incidencias/GetEstatusIncidencia',
  C033TipoIncidencia: 'SIAP/Catalogos/Incidencias/GetTipoIncidencia',
  C034TipoSubIncidencia: 'SIAP/Catalogos/Incidencias/GetTipoSubIncidencia',
  C037TiposPlantillasDeNombramientos: 'SIAP/Catalogos/GetTiposPlantillasDeNombramientos',
  C043TiposAsunto: 'SIAP/Catalogos/GetTiposAsunto'
  
};

export default siap;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/siap/catalogos/siap.js
// module id = null
// module chunks = 